import React , { useEffect, useRef, useState } from 'react';
// Import skelton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import Button from "../button/button";
import MuiSelect from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import MenuItem from "@mui/material/MenuItem";

import sampleFile from "../../asstes/sample.pdf";

// Import the main component
import { Viewer, Worker, SpecialZoomLevel } from "@react-pdf-viewer/core";

function ProfileDetailsBoard({applyTransition=false, hideProfile=false, loading=false, showLogin=false, profile,  meetingDetailPage=false, addCandidate=false, addToBoard, boards, showBoards=false, changeBoard, saveButtonStyle, selectedBoard, addSelection, toCandidates }) {

    const StyledInput = styled(InputBase)(({ theme }) => ({
        "& .MuiInputBase-input": {
          "&:focus": {
            borderRadius: 4,
            borderColor: "",
            boxShadow: "",
          },
        },
    }));
  
    return (
    <div
    className={`${addCandidate ? 'omd-1:w-[98%] mx-auto' : 'col-span-6'} ${
    applyTransition ? "showProfileTransition" : ""
    } ${hideProfile ? 'hideProfileTransition' : "" }`}
    >
        {/* Add div */}
        <div className="bg-profile_background h-2xl w-full col-span-12"></div>

        {/* Body */}
        <div className="bg-blue-7 flex justify-center">
        <div className="w-11/12 lg:self-center ">
            {/* Personal View Sections */}
            <div className="col-span-12 grid grid-cols-12 gap-3 -mt-5">
            {/* Basic Info section */}
            <div className="bg-white-1 col-span-12 grid grid-cols-12 gap-3 rounded font-Poppins pl-3 pt-5  pb-1 mb-1">
                {/* DP and Interview Button*/}
                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 grid grid-cols-12 gap-3">
                    <div className="col-span-6 h-20 w-20 -mt-24 md:h-40 md:w-40 md:-mt-28">
                        <Skeleton
                        circle={true}
                        height={`100%`}
                        width={`100%`}
                        />
                    </div>
                    </div>
                ) : (
                    <div
                    className={`col-span-12 grid grid-cols-12 gap-3`}
                    >
                        <div className='col-span-6'>
                            <div className="h-28 w-28 -mt-20 md:h-40 md:w-40 md:-mt-28 rounded-full bg-white-1 border-grey-1 border-2 relative">
                                <img
                                className={`md:h-28 md:w-[5.5rem] h-22 w-16 flex justify-center items-center mt-3 md:mt-5 absolute left-6 md:left-8`}
                                src={profile?.emoji_url}
                                alt="Avatar"
                                />
                            </div>
                            <div className={`flex mt-3`}>
                                <span className="text-black-1 text-2xl md:font-semibold">
                                {profile?.full_name}
                                </span>
                            </div>
                        </div>
                        <div className='col-span-6'>
                            {addCandidate && !showBoards && <div className="flex justify-end mr-2 md:mr-5">
                                <Button
                                name="Interview"
                                buttonType="Interview"
                                value="Add to a board"
                                onClick={() => addToBoard()} />
                            </div>}
                            {showBoards && boards.length > 0 && (
                                <div className="flex space-x-2 omd-1:flex-col justify-end mr-2 md:mr-5">
                                {saveButtonStyle == "w-32 bg-pink-1" ? (
                                    <MuiSelect
                                    labelId="boards"
                                    id="boards"
                                    className="-mt-2"
                                    // defaultOpen={true}
                                    label={selectedBoard}
                                    value={selectedBoard}
                                    onChange={changeBoard}
                                    input={<StyledInput />}
                                    >
                                    {boards.map((b) => (
                                        <MenuItem key={b.name} value={b.name}>
                                        {b.name}
                                        </MenuItem>
                                    ))}
                                    </MuiSelect>
                                ) : (
                                    <p className="flex items-center mr-6 text-base -mt-2 md:-mt-4 font-semibold">
                                    {selectedBoard}
                                    </p>
                                )}
                            
                                <Button
                                    value={
                                    saveButtonStyle == "w-32 bg-pink-1"
                                        ? "Save"
                                        : "Saved"
                                    }
                                    buttonType="search"
                                    className={`md:${saveButtonStyle}`}
                                    onClick={() => addSelection()}
                                />
                                </div>
                            )}
                        </div>
                    </div>
                )}
                </div>

                {/* Name */}
                <div className="col-span-12">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 mt-2 grid grid-cols-12 gap-3">
                    <div className="col-span-12 md:col-span-3">
                        <Skeleton height={35} width={300} />
                    </div>
                    </div>
                ) : (
                    <div className="col-span-12 grid grid-cols-12 gap-3">
                    {/* Add text */}
                    <div
                        className={`flex col-span-12 md:col-span-8 lg:col-span-9`}
                    >
                        <span className="text-black-2 text-xs font-normal -mt-2">
                        {profile?.email}
                        </span>
                    </div>
                    </div>
                )}
                </div>

                {/* Location and TimeZone */}
                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 flex">
                    <Skeleton height={30} width={260} />
                    <div className="ml-40">
                        <Skeleton height={30} width={140} />
                    </div>
                    </div>
                ) : (
                    <div className="col-span-12 grid grid-cols-12 gap-3">
                    {/* Add location */}
                    {profile?.location && (
                        <div className="col-span-12 grid grid-cols-12">
                        <div className="flex col-span-6">
                            <img
                            className="mr-1 h-4 mt-1"
                            src="/location_icon2.svg"
                            alt="Avatar"
                            />
                            <span className="text-black-1 text-base font-light">
                            {profile?.location}
                            </span>
                        </div>
                        <div className="flex col-span-6">
                            {/* Render exp */}
                            {profile?.timezone ? (
                            <div className="text-base font-light flex">
                                <svg
                                className="mt-1 h-4 w-4 fill-current text-black-1 mr-1"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="18"
                                height="18"
                                >
                                <path fill="none" d="M0 0h24v24H0z" />
                                <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z" />
                                </svg>
                                {profile?.timezone
                                .split(" ")[0]
                                .replace(/[\(\)]/g, "")}
                            </div>
                            ) : null}
                        </div>
                        </div>
                    )}
                    </div>
                )}
                </div>

                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <div className="col-span-12 flex">
                    <Skeleton height={30} width={260} />
                    <div className="ml-40">
                        <Skeleton height={30} width={140} />
                    </div>
                </div>
                ) : (
                    <div className="grid grid-cols-12 gap-3 col-span-12">
                    {/* Add job title */}
                    <div className="col-span-12 grid grid-cols-12">
                        <div className="flex col-span-6">
                        {/* Render exp */}
                        {profile?.exp ? (
                            <div className="w-full text-xs font-normal text-black-2">
                            <div>EXPERIENCE</div>
                            <div className="text-black-1 text-sm">
                                {/* Text */}
                                {profile?.exp} Years
                            </div>
                            </div>
                        ) : null}
                        </div>
                        <div className="flex col-span-6">
                        {/* Render expected_hourly_rate */}
                        {profile?.expected_hourly_rate ? (
                            <div className="w-full text-sm font-semibold text-black-1">
                            <div className="text-black-2 text-xs font-normal">
                                {" "}
                                HOURLY RATE
                            </div>
                            {/* Text */}
                            <div>${new Intl.NumberFormat().format(profile?.expected_hourly_rate)}</div>
                            </div>
                        ) : null}
                        </div>
                    </div>
                    </div>
                )}
                </div>

                {/* Add text */}
                <div className="col-span-12 grid grid-cols-12 gap-3">
                {/* Show skelton on loading*/}
                {loading ? (
                    <Skeleton height={35} width={330} />
                ) : (
                    <div className="col-span-12">
                    {/* Show skills */}
                    <div className="col-span-12 md:col-span-10 flex flex-wrap">
                        {/* Render tags */}
                        {profile?.skill_level?.length > 0
                        ? profile?.skill_level.map((element, index) => (
                            <div
                                key={index}
                                className={`text-black-1 text-sm p-1 mr-2 mb-2 rounded-sm border-blue-7 bg-white-1 border-2 font-text whitespace-nowrap`}
                            >
                                {element.skill}
                            </div>
                            ))
                        : null}
                    </div>
                    </div>
                )}
                </div>
            </div>

            {/* Show download */}
            <div className="col-span-12 bg-white-1 rounded font-Poppins p-5 mb-5 z-1">
                {loading ? (
                <div className="col-span-12">
                    <div className="">
                    <Skeleton height={35} width={300} />
                    </div>
                </div>
                ) : (
                <div>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js">
                    <div
                        style={{
                        border: "1px solid rgba(0, 0, 0, 0.3)",
                        height: "1050px",
                        }}
                    >
                        <Viewer
                        fileUrl={profile?.cv_link ? profile?.cv_link : sampleFile}
                        defaultScale={SpecialZoomLevel.PageFit}
                        />
                    </div>
                    </Worker>
                </div>
                )}
            </div>
            
            {/* Other Candidates Button */}
            {addCandidate && <div className='md:hidden col-span-12 flex justify-center mb-5'>
                <div className="font-semibold flex text-blue-4 cursor-pointer " onClick={() => toCandidates()}>View other candidates
                    <svg className="ml-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12.172 12L9.343 9.172l1.414-1.415L15 12l-4.243 4.243-1.414-1.415z" fill="rgb(32,78,207)"/></svg>
                </div>
            </div>}
            </div>
        </div>
        </div>
    </div>
  )
}

export default ProfileDetailsBoard